import React from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import { Image } from "../../components/Image/Image";
import { Button } from "../../components/Button/Button";
import styles from "./Streaming.module.scss";
import streamingHeroPhoto from "../../images/streaming-hero-photo.png";
import streamingSecondaryPhoto from "../../images/streaming-secondary-photo.png";
import { SVGIcon } from "../../components/SVGIcon/SVGIcon";

export const Streaming = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.streaming.title}</title>
        <meta
          name="description"
          content="Bundle your live streaming internet TV service with Cityside Fiber— the best & most reliable way to stream on your new internet connection."
        />

        <meta property="og:title" content={`${ROUTES.streaming.title}`} />
        <meta property="og:description" content="Bundle your live streaming internet TV service with Cityside Fiber— the best & most reliable way to stream on your new internet connection." />
        <meta property="og:url" content="https://www.citysidefiber.com/streaming" />
      </Helmet>

      <section className={styles.hero}>
        <div className="grid-12 container">
          <div className="img">
            <Image
              sources={[{ src: streamingHeroPhoto, breakpoint: "default" }]}
              alt="man woman and dog lounging on a sofa with a remote control"
              loading="eager"
            />
          </div>
          <div className="text">
            <div className="logo">
              <SVGIcon id="my-bundle-logo" color="white" />
            </div>
            <h1>Cityside and MyBundle</h1>
            <h2 className="headline__h2">We make streaming easy!</h2>
            <div>
              <p>
                We’ve partnered with MyBundle to bring you streaming options
                that make switching from outdated cable TV easy!
              </p>
              <Button
                className="bg-color--white color--marina-blue"
                href="https://streaming.citysidefiber.com/tv"
                size="lg"
              >
                Explore Streaming TV
              </Button>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.mainContent}>
        <div className="grid-12 container">
          <Image
            sources={[{ src: streamingSecondaryPhoto, breakpoint: "default" }]}
            alt="person holding a smartphone with a streaming app"
            loading="eager"
          />
          <div className="info">
            <h3>MyBundle Marketplace</h3>
            <p>
              Looking for a great deal on Streaming TV Services, Music, Apps,
              and more?
            </p>
            <Button
              className="color--white"
              gradient="blue"
              href="https://streaming.citysidefiber.com/discover"
              size="lg"
            >
              Discover Streaming TV
            </Button>
            <h3>Find TV Shows and Movies</h3>
            <p>
              Keep track of your favorite shows and movies in one place, share
              watchlists with friends, and discover new content with our
              streaming TV guide.
            </p>
            <Button
              className="color--white"
              gradient="blue"
              href="https://streaming.citysidefiber.com/shows-and-movies"
              size="lg"
            >
              Personalized Streaming Guide
            </Button>
            <h3>Still paying for cable boxes and unused channels?</h3>
            <p>
              A MyBundle package can save you up to 50% every month! Cut the
              Cord and save $$$$.
            </p>
            <Button
              className="color--white"
              gradient="blue"
              href="https://streaming.citysidefiber.com/start"
              size="lg"
            >
              Personalized Streaming Guide
            </Button>
            <p>
              <a href="https://streaming.citysidefiber.com/app">Click Here</a>{" "}
              and download the MyBundle app today!{" "}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
